import React, { Component } from 'react';

class Header extends Component {
  renderSocialLinks(networks) {
    if (!Array.isArray(networks)) {
      return null;
    }

    return networks.map(function(network) {
      return (
        <a
          className="link-chip"
          href={network.url}
          key={network.name}
          target={network.url && network.url.indexOf('mailto:') === 0 ? undefined : '_blank'}
          rel={network.url && network.url.indexOf('mailto:') === 0 ? undefined : 'noreferrer'}
          aria-label={network.label || network.name}
          title={network.label || network.name}
        >
          {network.label || network.name}
        </a>
      );
    });
  }

  renderHighlights(highlights) {
    if (!Array.isArray(highlights)) {
      return null;
    }

    return highlights.map(function(highlight) {
      return (
        <li key={highlight}>
          <span className="check-mark" aria-hidden="true">+</span>
          <span>{highlight}</span>
        </li>
      );
    });
  }

  renderPersona(items) {
    if (!Array.isArray(items)) {
      return null;
    }

    return items.map(function(item) {
      return (
        <li key={item}>{item}</li>
      );
    });
  }

  render() {
    var data = this.props.data || {};
    var address = data.address || {};
    var secondaryAction = data.secondaryAction || {};

    return (
      <section id="home" className="hero-section">
        <nav className="site-nav" aria-label="Primary navigation">
          <a className="brand-mark" href="#home" aria-label="Raj Tandukar home">
            RT
          </a>
          <div className="nav-links">
            <a href="#about">Profile</a>
            <a href="#resume">Experience</a>
            <a href="#portfolio">Work</a>
            <a href="#contact">Contact</a>
          </div>
        </nav>

        <div className="hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">{data.description}</p>
            <h1>{data.name}</h1>
            <p className="hero-role">{data.occupation}</p>
            <p className="hero-lede">{data.headline}</p>

            <ul className="hero-highlights">
              {this.renderHighlights(data.heroHighlights)}
            </ul>

            <div className="hero-actions">
              <a className="button primary" href="#contact">
                Contact Raj
              </a>
              {secondaryAction.url && (
                <a className="button secondary" href={secondaryAction.url} target="_blank" rel="noreferrer">
                  {secondaryAction.label}
                </a>
              )}
            </div>
          </div>

          <aside className="hero-card" aria-label="Professional snapshot">
            <img src={'images/' + data.image} alt={data.name} />
            <div className="hero-card-content">
              <p className="location">
                {address.city}, {address.state}, Australia
              </p>
              <ul className="persona-list">
                {this.renderPersona(data.persona)}
              </ul>
              <div className="hero-socials">
                {this.renderSocialLinks(data.social)}
              </div>
            </div>
          </aside>
        </div>
      </section>
    );
  }
}

export default Header;
